import ComboBox from "../../Control/ComboBox/ComboBox";
import { ColumnLabel } from "../../Layout/ColumnLabel";
import { ComboBoxOption } from "../../../models/Input";
import { SortType, getSortByOptions } from "../../../models/Product";

export type SortBySelectorProps = {
    value: ComboBoxOption<SortType>,
    update: (values: ComboBoxOption<SortType>) => void,
    defaultSortOptions: SortType
}

export function SortBySelector(props: SortBySelectorProps) {
    const defaultOption = props.defaultSortOptions || "Release Date (Desc)";
    const options = getSortByOptions();

    return (
        <ColumnLabel label="Sort By">
            <ComboBox
                selections={props.value}
                isMulti={false}
                options={options}
                defaultOption={{ label: defaultOption, value: defaultOption }}
                classNames={{
                    menuPortal: (props) => "!z-50"
                }}
                onChange={(newSelections) => props.update(newSelections || { label: defaultOption, value: defaultOption })} />
        </ColumnLabel>
    )
}